import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {DumpsterFire} from "../DumpsterFire";
import {gsap} from "gsap";
import {StageLayer} from "@nolimitcity/slot-keypad/bin/core/app/StageLayer";
import {DumpsterFireGameMode} from "../server/DumpsterFireGameMode";
import {DumpsterFireSound} from "../sound/DumpsterFireSound";
import {ContinueButton} from "@nolimitcity/slot-keypad/bin/core/app/gui/buttons/concretebuttons/ContinueButton";

export class UpgradeBet extends PIXI.Container implements StageLayer {

    yesButton: ContinueButton;
    noButton: ContinueButton;
    yesButtonCallback: Function;
    noButtonCallback: Function;
    controller: FlowStateController;
    text: PIXI.Text;
    private amount: PIXI.Text;
    private readonly _promptMask: PIXI.Sprite;
    replayClick: PIXI.spine.Spine;
    private musicName: string = ''

    constructor() {
        super();
        this._promptMask = new PIXI.Sprite(DumpsterFire.assetLoader.getTextures("greenBanner")[0]);
        this._promptMask.position.set(-56, 20);
        this.addChild(this._promptMask);
        // this.mask = this._promptMask;

        const translations = DumpsterFire.apiPlugin.translations;
        const textStyle = new PIXI.TextStyle({
            fill: "#FFFF00",
            fontFamily: "Helvetica",
            fontSize: 55,
            fontStyle: "oblique",
            fontWeight: "bolder",
            lineJoin: "round",
            strokeThickness: 7,
            wordWrapWidth: 670,
            padding: 10,
            wordWrap: true,
        });
        const upgradeBetCost = DumpsterFire.model.data.extraSpinCost;
        const parsedText = translations.translate("Buy Extra Spin!");
        this.text = new PIXI.Text(parsedText, textStyle);
        this.amount = new PIXI.Text(DumpsterFire.apiPlugin.currency.format(upgradeBetCost), textStyle);
        this.text.position.set(364, 260);
        this.text.anchor.set(0.5, 0.5);

        this.amount.position.set(364, 350);
        this.amount.anchor.set(0.5, 0.5);

        this.yesButton = new ContinueButton(translations.translate("YES"));
        this.yesButton.setSize(240, 120);
        this.yesButtonCallback = this.clickedYes;
        this.yesButton.addClickCallback(() => this.yesButtonCallback());
        this.yesButton.position.set(210, 500);
        this.yesButton.pivot.set(this.yesButton.width * 0.5, this.yesButton.height * 0.5);
        this.yesButton.enable(false);
        this.yesButton.alpha = 0;
        this.addChild(this.text);
        this.addChild(this.amount);

        this.noButton = new ContinueButton(translations.translate("NO"));
        this.noButton.setSize(240, 120);
        this.noButtonCallback = this.clickedNo;
        this.noButton.addClickCallback(() => this.noButtonCallback());
        this.noButton.position.set(510, 500);
        this.noButton.pivot.set(this.noButton.width * 0.5, this.noButton.height * 0.5);
        this.noButton.enable(false);
        this.noButton.alpha = 0;
        this.alpha = 0;
        this.addChild(this.noButton);
        this.addChild(this.yesButton);

        this.replayClick = new PIXI.spine.Spine(DumpsterFire.assetLoader.getSpineAsset("clickButton"));
        this.replayClick.visible = false;
        this.replayClick.position.set(360, 500);
        this.addChild(this.replayClick);
    }

    enable(controller: FlowStateController): gsap.core.Timeline {
        return gsap.timeline({
            delay: 0.1
        })
            .add(() => {
                this.controller = controller;
                this.yesButton.enable(true);
                this.noButton.enable(true);
                this.text.visible = true;
                this._promptMask.visible = true;
                const extraSpinCost: number = DumpsterFire.model.data.extraSpinCost;
                this.amount.text = `${DumpsterFire.apiPlugin.currency.format(extraSpinCost)}`;
            })
            .add(gsap.to(this, {duration: 0.1, alpha: 1}), '<')
            .add(gsap.to(this.noButton, {duration: 0.1, alpha: 1}), '<')
            .add(gsap.to(this.yesButton, {duration: 0.1, alpha: 1}), '<')
    }

    clickedYes(): gsap.core.Timeline {
        return gsap.timeline()
            .add(() => {
                this.noButton.enable(false);
                this.yesButton.enable(false);
                DumpsterFire.soundPlayer.playSound(DumpsterFire.soundPlayer.getRandomNumber(DumpsterFireSound.CLICK_YES_ARRAY));
            }, 0)
            .add(gsap.to(this, {duration: 0.1, alpha: 0}), 0)
            .add(gsap.to(this.noButton, {duration: 0.1, alpha: 0}), 0)
            .add(gsap.to(this.yesButton, {duration: 0.1, alpha: 0}), 0)
            .add(() => {
                if (DumpsterFire.model.data.mode === DumpsterFireGameMode.NORMAL) {
                    DumpsterFire.allReelsView.removeAllMulti()
                    DumpsterFire.bgMulti.removeMulti();
                    DumpsterFire.bgFinalMulti.removeFinalMulti();
                    DumpsterFire.fireFrame.removeAllSpines();
                }
                DumpsterFire.apiPlugin.betHandler.zeroBet({playExtraSpin: "yes"});
                const newWinAmount: number = DumpsterFire.model.data.accumulatedRoundWin - DumpsterFire.model.data.extraSpinCost;
                DumpsterFire.keypadPlugin.setWin(newWinAmount, true, DumpsterFire.isESWinBelowStake());
                this.controller.finish();
            }, 0.2)
    }

    clickedNo(): gsap.core.Timeline {
        return gsap.timeline()
            .add(() => {
                this.noButton.enable(false);
                this.yesButton.enable(false);
                if (DumpsterFire.model.data.mode === DumpsterFireGameMode.NORMAL) {
                    DumpsterFire.allReelsView.removeWinMulti()
                    DumpsterFire.bgMulti.removeMulti();
                    DumpsterFire.bgFinalMulti.removeFinalMulti();
                    DumpsterFire.fireFrame.removeAllSpines();
                }
                DumpsterFire.soundPlayer.playSound(DumpsterFireSound.EXTRA_SPIN_NO);
            }, 0)
            .add(gsap.to(this, {duration: 0.1, alpha: 0}), 0)
            .add(gsap.to(this.noButton, {duration: 0.1, alpha: 0}), 0)
            .add(gsap.to(this.yesButton, {duration: 0.1, alpha: 0}), 0)
            .add(DumpsterFire.transitionView.playTransitionAnim(), 0.1)
            .add(() => {
                DumpsterFire.apiPlugin.betHandler.zeroBet({playExtraSpin: "no"});
                this.controller.finish();
            }, 0.2)
            .add(() => {
                DumpsterFire.backgroundElements.setMode(DumpsterFireGameMode.NORMAL);
                DumpsterFire.gameLogo.setMode(DumpsterFireGameMode.NORMAL);
            }, '<0.5')
    }

    replay(controller: FlowStateController): gsap.core.Timeline {
        const option: string = DumpsterFire.model.data.nextPlayerInteraction.playExtraSpin === "yes" ? "YES" : "NO";
        let soundName: string = DumpsterFireSound.EXTRA_SPIN_NO;
        if (option === "yes") {
            soundName = DumpsterFire.soundPlayer.getRandomNumber(DumpsterFireSound.CLICK_YES_ARRAY);
        }
        return gsap.timeline()
            .add(() => {
                this.controller = controller;
                this.yesButton.enable(false);
                this.noButton.enable(false);
                this.text.visible = true;
                this._promptMask.visible = true;
                const extraSpinCost: number = DumpsterFire.model.data.extraSpinCost;
                this.amount.text = `${DumpsterFire.apiPlugin.currency.format(extraSpinCost)}`;
            })
            .add(gsap.to(this, {duration: 0.1, alpha: 1}), '<')
            .add(gsap.to(this.noButton, {duration: 0.2, alpha: 1}), '>')
            .add(gsap.to(this.yesButton, {duration: 0.2, alpha: 1}), '<')
            .add(() => {
                this.replayClick.visible = true;
                this.replayClick.updateTransform();
                this.replayClick.position.x = option == "NO" ? 510 : 210;
                DumpsterFire.soundPlayer.playSound(soundName);
            }, '>1')
            .add(DumpsterFire.createTimelineForAnimation(this.replayClick, 0, "animation", false), ">")
            .add(() => {
                DumpsterFire.apiPlugin.betHandler.zeroBet({playExtraSpin: option});
                if (option == "YES") {
                    const newWinAmount = DumpsterFire.model.data.accumulatedRoundWin - DumpsterFire.model.data.extraSpinCost;
                    DumpsterFire.keypadPlugin.setWin(newWinAmount, true, DumpsterFire.isWinBelowStake());
                }
                this.replayClick.visible = false;
                this.replayClick.state.clearTracks();
                controller.finish();
            }, `>2.0`)
            .add(gsap.to(this, {duration: 0.1, alpha: 0}), '<')
            .add(gsap.to(this.noButton, {duration: 0.1, alpha: 0}), '<')
            .add(gsap.to(this.yesButton, {duration: 0.1, alpha: 0}), '<')
    }
}